"use client";

import { c as _c } from "react/compiler-runtime";
import GridColumn from "../common/grid-column/grid-column";
import GridRow from "../common/grid-row/grid-row";
import ResourcesArticleBlockAuto from "../resources/resources-article-block/resources-article-block-auto";
import { ArticleData, GlossaryPageData } from "@/sanity/interfaces";
import { useSearchParams } from "next/navigation";
import Link from "../common/link/link";
import GlossaryLetter from "./glossary-letter";
import { GLOSSARY_TERMS_PER_PAGE } from "@/sanity/constants";
import { useEffect } from "react";
import { usePerformance } from "@/contexts/performance-context";
import Pagination from "../common/pagination/Pagination";
interface IGlossaryProps {
  data: GlossaryPageData;
  latestArticles: ArticleData[];
  beforeParamTime: number;
  beforeQueryTime: number;
  afterQueryTime: number;
}
const alphabet = "abcdefghijklmnopqrstuvwxyz".split("");
const Glossary = props => {
  const $ = _c(39);
  const {
    data,
    latestArticles,
    beforeParamTime,
    beforeQueryTime,
    afterQueryTime
  } = props;
  const {
    glossaryData,
    glossaryTerms,
    glossaryTermsCount,
    glossaryTermTitles
  } = data;
  const {
    checkTimeElapsed
  } = usePerformance();
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("page") || 1;
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currentPage = Number(t0);
  let t1;
  if ($[2] !== searchParams) {
    t1 = searchParams.get("letter") || "";
    $[2] = searchParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const selectedLetter = t1;
  const totalPages = Math.ceil(glossaryTermsCount / GLOSSARY_TERMS_PER_PAGE);
  let t2;
  if ($[4] !== selectedLetter) {
    t2 = page => {
      const params = new URLSearchParams();
      if (selectedLetter) {
        params.set("letter", selectedLetter);
      }
      if (page > 1) {
        params.set("page", page.toString());
      }
      const queryString = params.toString();
      return queryString ? `${"/glossary"}?${queryString}` : "/glossary";
    };
    $[4] = selectedLetter;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const getPageHref = t2;
  let t3;
  if ($[6] !== glossaryTermTitles) {
    t3 = letter => glossaryTermTitles.some(term => term.title?.toLowerCase().startsWith(letter));
    $[6] = glossaryTermTitles;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const hasTermsForLetter = t3;
  let t4;
  if ($[8] !== afterQueryTime || $[9] !== beforeParamTime || $[10] !== beforeQueryTime || $[11] !== checkTimeElapsed) {
    t4 = () => {
      checkTimeElapsed(beforeParamTime, "Resource category page before param started");
      checkTimeElapsed(beforeQueryTime, "Resource page before query started");
      checkTimeElapsed(afterQueryTime, "Resource page after query completed");
    };
    $[8] = afterQueryTime;
    $[9] = beforeParamTime;
    $[10] = beforeQueryTime;
    $[11] = checkTimeElapsed;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  useEffect(t4, t5);
  let t6;
  if ($[14] !== glossaryData) {
    t6 = glossaryData && <div className="flex flex-col md:mb-[56px]"><h1 className="mb-3 font-[Lora] text-[28px] font-bold leading-[33.6px] md:mb-4 md:text-[56px] md:leading-[67.2px] md:text-[#373A36]">{glossaryData.title}</h1><span className="font-['Work_Sans'] text-[16px] font-normal text-[#373A36] md:text-[18px]">{glossaryData.description}</span></div>;
    $[14] = glossaryData;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== hasTermsForLetter || $[17] !== selectedLetter) {
    t7 = alphabet.map(letter_0 => <GlossaryLetter key={letter_0} letter={letter_0} isSelected={selectedLetter === letter_0} isDisabled={!hasTermsForLetter(letter_0)} />);
    $[16] = hasTermsForLetter;
    $[17] = selectedLetter;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t7) {
    t8 = <div className="my-[24px] flex overflow-x-auto scroll-smooth whitespace-nowrap bg-white py-2 md:mb-[40px]"><div className="flex">{t7}</div></div>;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== glossaryTerms) {
    t9 = glossaryTerms.map(_temp);
    $[21] = glossaryTerms;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = <div className="flex w-full flex-col self-stretch">{t9}</div>;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== currentPage || $[26] !== getPageHref || $[27] !== totalPages) {
    t11 = <Pagination currentPage={currentPage} totalPages={totalPages} getPageHref={getPageHref} className="mb-[52px] mt-8" />;
    $[25] = currentPage;
    $[26] = getPageHref;
    $[27] = totalPages;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t10 || $[30] !== t11 || $[31] !== t6 || $[32] !== t8) {
    t12 = <GridRow><GridColumn className="flex flex-col gap-[56px]"><div className="z-10 mt-[24px] md:mt-[56px]">{t6}{t8}{t10}{t11}</div></GridColumn></GridRow>;
    $[29] = t10;
    $[30] = t11;
    $[31] = t6;
    $[32] = t8;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== latestArticles) {
    t13 = latestArticles && <ResourcesArticleBlockAuto articles={latestArticles} title="Recent Articles" />;
    $[34] = latestArticles;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t12 || $[37] !== t13) {
    t14 = <>{t12}{t13}</>;
    $[36] = t12;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
};
export default Glossary;
function _temp(item) {
  return <div key={item._id} className="mb-5 flex flex-col gap-[16px] rounded-[6px] border border-[rgba(74,74,74,0.50)] bg-white p-[17px] md:w-[70%] md:px-[29px] md:pb-[24px] md:pt-[29px]"><Link href={`/glossary/${item?.slug?.current ?? ""}`} className="group"><div className="font-['Work_Sans'] text-[18px] font-semibold text-[#373A36] hover:text-[#005472] hover:underline md:text-[24px]">{item.title}</div></Link><p className="my-3 font-['Work_Sans'] text-[16px] leading-[22px] text-[#4A4A4A] md:text-[18px] md:leading-[24px]">{item.definition}</p></div>;
}